import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { List, Layout, Button, Row, Col, Input } from "antd";
import api from "../../Api";

const { Content } = Layout;
const { Search } = Input;

const DiscountsDataView = () => {
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    const getDiscounts = async () => {
      const res = await api.discounts().get();
      const filteredArr = res.data.reduce((acc, current) => {
        const x = acc.find((item) => item.customerUid === current.customerUid);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      setDiscounts(filteredArr);
      setLoading(false);
    };
    const getCustomers = async () => {
      const { data } = await api.getCustomers().get();
      setCustomers(data);
    };
    getCustomers();
    getDiscounts();
  }, []);

  return (
    <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
      <Row type="flex" justify="space-between" align="middle">
        <Col span={6}>
          <h1>Discounts</h1>
        </Col>
        <Col span={12}>
          <Search
            type="text"
            name="search"
            enterButton="Search"
            placeholder="input search text"
          />
        </Col>
        <Col span={6}>
          <div className="addNew">
            <Link to={{ pathname: `/discount/?isNew=true` }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                className="green-btn"
              >
                Add new
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <div
        style={{
          padding: 24,
          background: "#fff",
          textAlign: "left",
          borderRadius: 12,
        }}
      >
        <List
          itemLayout="horizontal"
          loading={loading}
          pagination={{
            onChange: (page) => {
              console.log(page);
            },
            pageSize: 20,
          }}
          dataSource={discounts}
          renderItem={(discount) => (
            <List.Item key={discount.id}>
              <List.Item.Meta
                title={
                  discount &&
                  customers &&
                  customers.some((x) => x.id === discount.customerUid)
                    ? customers.find((x) => x.id === discount.customerUid)
                        .businessName
                    : ""
                }
                description={discount ? discount.name : ""}
              />
              <Link
                to={{
                  pathname: `/discount/?discountCustomer=${discount.customerUid}&isNew=false`,
                }}
              >
                <Button>Show/Edit</Button>
              </Link>
            </List.Item>
          )}
        />
      </div>
    </Content>
  );
};

export default DiscountsDataView;
